////////////////////////////////////////////////////////////////////////////////
//
// App API module
//
////////////////////////////////////////////////////////////////////////////////

import ApiService from "@/services/api.service";

////////////////////////////////////////////////////////////////////////////////

const site = {
    /**
     * Get all accounts
     * @returns {Promise<AxiosResponse<any>>}
     */
    all: () => ApiService.getT('site'),

    /**
     * Delete account with name
     * @param name
     * @returns {Promise<AxiosResponse<any>>}
     */
    del: (name) => ApiService.deleteT(`site/${name}`),

    /**
     * Add a account with data
     * @param data
     * @returns {Promise<AxiosResponse<any>>}
     */
    add: (data) => ApiService.postT('site', data),

    /**
     * Save Site with data
     * @param name dataview resource name
     * @param data { "description": "", "name": "", ... }
     */
    save: (name, data) => {
        const dataCopy = { ...data }
        if (name === dataCopy.name) {
            delete dataCopy.name
        }
        const putData = { operator: { $set: dataCopy } }
        return ApiService.putT(`site/${name}`, putData)
    },
    uploadSiteFile(formData) {
        return ApiService.postT('file', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
   
    listSiteFiles(siteId) {
        return ApiService.getT('file', {
            params: {
                level: 'site',
                site_id: siteId
            }
        });
    },
    
    deleteSiteFile(fileId) {
        return ApiService.deleteT(`file/${fileId}`);
    },
    
    deleteAllSiteFiles(siteId)  {
        return ApiService.deleteT('files', {
            params: {
                level: 'site',
                site_id: siteId
            }
        });
    },
    uploadSiteFirmware(formData) {
                return ApiService.postT('firmware', formData, {
            headers: {'Content-Type': 'multipart/form-data'}
        })
                },

    listSiteFirmware(siteId,  deviceType = 'CC2') {
        return ApiService.getT(`firmware/list/${deviceType}`, {
        params: {
            site_id: siteId,
            level: 'site',
            include_entity: true  
        }
    });
    
  },
  uploadSiteIcon(formData) {
    return ApiService.postT('icon', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
},

listSiteIcons(siteId) {
    return ApiService.getT('icon', {
        params: {
            site_id: siteId,
            level: 'site'
        }
    });
},

deleteSiteIcon(iconId) {
    return ApiService.deleteT(`icon/${iconId}`);
},

deleteAllSiteIcons(siteId) {
    return ApiService.deleteT('icons', {
        params: {
            level: 'site',
            site_id: siteId
        }
    });
},
  
    deleteSiteFirmware(firmwareId) {
        return ApiService.deleteT(`firmware/${firmwareId}`)
    },
   deleteAllSiteFirmware(siteId, deviceType) {
    return ApiService.deleteT('firmware', {
        params: {
            level: 'site',
            site_id: siteId,
            device_type: deviceType
        }
    });
},

    
}

export default site;